/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Cue_Arms_OutInputs */

const en_us2_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move your arms away from your body.`)
};

const pt_br2_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afaste os braços do corpo.`)
};

const es_419_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Separa los brazos del cuerpo.`)
};

const pt_pt2_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afasta os braços do corpo.`)
};

const fr_fr2_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écarte les bras du corps.`)
};

const de_de2_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arme vom Körper weg.`)
};

const it_it2_body_assessment_cue_arms_out = /** @type {(inputs: Body_Assessment_Cue_Arms_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stacca le braccia dal corpo.`)
};

/**
* | output |
* | --- |
* | "Move your arms away from your body." |
*
* @param {Body_Assessment_Cue_Arms_OutInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_cue_arms_out = /** @type {((inputs?: Body_Assessment_Cue_Arms_OutInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Cue_Arms_OutInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_cue_arms_out(inputs)
	if (locale === "es-419") return es_419_body_assessment_cue_arms_out(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_cue_arms_out(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_cue_arms_out(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_cue_arms_out(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_cue_arms_out(inputs)
	return en_us2_body_assessment_cue_arms_out(inputs)
});
export { body_assessment_cue_arms_out as "body-assessment.cue.arms_out" }